import { render, staticRenderFns } from "./ArticleFamilySelector.vue?vue&type=template&id=156c2b58&scoped=true&"
import script from "./ArticleFamilySelector.vue?vue&type=script&lang=js&"
export * from "./ArticleFamilySelector.vue?vue&type=script&lang=js&"
import style0 from "./ArticleFamilySelector.vue?vue&type=style&index=0&id=156c2b58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156c2b58",
  null
  
)

export default component.exports